export const ROLES = {
    d5_nodes_priv: 'd5_nodes_priv',
    d5_nodes_ro: 'd5_nodes_ro',
    d5_nodes_rw: 'd5_nodes_rw',
};

export const hasRole = (permissions, roleOrRoles) => {
    if (!Array.isArray(permissions)) return false;
    const roles = Array.isArray(roleOrRoles) ? roleOrRoles : [roleOrRoles];
    return permissions.some(permission => roles.includes(permission));
};
